import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='annuity-faq-income-payment'
    backgroundVariant='lightC'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          Choose Your Income Payment Option
        </Typography>
        <Typography nextElement='typography'>
          When you&#39;re ready to begin receiving income from your annuity, how much income you will receive depends on how much you put into the annuity and your age when the income phase begins&#8212;the basic logic being the older you are, the shorter your remaining life expectancy, therefore the larger the amount
          of income. The amount also depends on your sex, current interest rates and the income plan you select. Here are some of the general income plan options:
        </Typography>
        <Typography nextElement='typography'>
          <strong>Note:</strong> Not all income plans are available in all types of annuities. Please review the annuity contract or prospectus or consult your financial representative for further details.
        </Typography>
        <Typography nextElement='typography'>
          <strong>Lifetime or Period Certain</strong>
        </Typography>
        <Typography nextElement='typography'>
          When the time comes to draw an income from your annuity, determine how long you will need it to last.
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: 'Traditional, Roth, SEP or SIMPLE IRA contribution' },
            { bulletText: <>Re&#45;characterization</> },
            { bulletText: '60 Day Rollover' },
            { bulletText: 'Direct Rollover' },
            { bulletText: 'Roth Conversion' },
          ]}
        />
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Lifetime</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: <>If your priority is to always have a steady stream of income that you can&#39;t outlive, you&#39;ll want to choose a lifetime option.</> },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Period Certain</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: <>Perhaps you only want to supplement your income for a limited period of time such as might be the case during your early retirement years when you expect to be more active. Or, perhaps you need to provide income before a pension or social security begins&#8212;if so, you may want to take payout from your annuity for a specific period &#40;period certain&#41; of time typically ranging anywhere from 5 to 20 years.</> },
                  ]}
                  bulletType='disc' />
              </>),
            },

          ]}/>
        <Typography nextElement='typography'>
          <strong>Single or Joint &#38; Survivor &#40;Lifetime Plans&#41;</strong>
        </Typography>
        <Typography nextElement='typography'>
          You also need to determine whether you will be the sole annuitant, if you will have a joint annuitant, and if you would like to name a beneficiary:
        </Typography>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Single Life</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: 'Pays an income to a single annuitant as long as the annuitant is alive, and stops when the annuitant dies. This option allows for the largest income amount because it is based on the life of only one person, but may not be the best choice if it will leave a surviving spouse in need of income.' },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Single Life with &#34;Period Certain&#34;</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: <>Also referred to as a &#34;term certain.&#34; Income is paid as long as the sole annuitant is alive, but if the annuitant dies within the &#34;period certain,&#34; typically set between 5 and 20 years, the income will continue to a beneficiary, but only for the remainder of the period certain.</> },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Joint Life &#38; Survivor</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: 'This plan pays an income to joint annuitants, as long as one is alive. When one dies, income continues to the survivor, but may be reduced, depending on the terms of the contract.' },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (<>
                <strong>Joint Life &#38; Survivor with &#34;Period Certain&#34;</strong>
                <BulletedList
                  bulletedListData={[
                    { bulletText: <>Also referred to as a &#34;term certain.&#34; Income is paid as long as either joint annuitant is alive, but if both annuitants die within the &#34;period certain,&#34; typically set between 5 and 20 years, the income will continue to their beneficiary, but only for the remainder of the period certain.</> },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
      </Col>
    </Row>
  </SectionContainer>
);
